// extracted by mini-css-extract-plugin
export default {"click":"Refetch_click__mrsnv","reload":"Refetch_reload__og4Sm","button":"Refetch_button__5pxg5"};